export default "__VITE_ASSET__a3b320f3__"